import React from "react";
import { Card, Badge, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { DataTableHead, DataTableRow, DataTableItem, UserAvatar, DataTable, Button, Icon, DataTableBody, PaginationComponent, PreviewAltCard } from "../../../Component";
import { recentOrderData } from "./OrderData";
import MyLoader from "../../../../MyComp/UI/form/MyLoader";
import { BASE_URL_IMG, RUPEES_SYMBOL } from "../../../../assets/constants";
import { getSmartInitials } from "../../../../utils/Utils";

const RecentOrders = ({
  data,
  isLoading,
  paginate,
  currentPage,
  itemPerPage,
  limit,
  setonSearch,
  onSearch,
  setSearchText,
  onSearchText,
  setItemPerPage,
  pagination,
  onOrderClick,
  title,
}) => {
   // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };
  return (
   <DataTable className={"card-stretch"}>
        <div className="card-inner">
          <div className="card-title-group">
            <div className="card-title">
              <h5 className="title">{title}</h5>
            </div>
            <div className="card-tools me-n1">
              <ul className="btn-toolbar gx-1">
                <li>
                  <Button
                    href="#search"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setonSearch(true);
                    }}
                    className="btn-icon search-toggle toggle-search"
                  >
                    <Icon name="search"></Icon>
                  </Button>
                </li>
               {pagination&&<>
                <li className="btn-toolbar-sep"></li>
                <li>
                  <UncontrolledDropdown>
                    <DropdownToggle tag="a" className="btn btn-trigger btn-icon dropdown-toggle">
                      <Icon name="setting"></Icon>
                    </DropdownToggle>
                    <DropdownMenu end className="dropdown-menu-xs">
                      <ul className="link-check">
                        <li>
                          <span>Show</span>
                        </li>
                        {[10, 20, 30, 50, 100].map((num) => (
                          <li key={num}>
                            <DropdownItem
                              className={`dropdown-item ${itemPerPage === num ? "active" : ""}`}
                              href="#dropdownitem"
                              onClick={() => setItemPerPage(num)}
                            >
                              {num}
                            </DropdownItem>
                          </li>
                        ))}
                      </ul>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li>
               </>}
              </ul>
            </div>
            <div className={`card-search search-wrap ${onSearch && "active"}`}>
              <div className="search-content">
                <Button
                  onClick={() => {
                    setSearchText("");
                    setonSearch(false);
                  }}
                  className="search-back btn-icon toggle-search"
                >
                  <Icon name="arrow-left"></Icon>
                </Button>
                <input
                  type="text"
                  className="border-transparent form-focus-none form-control"
                  placeholder="Search..."
                  value={onSearchText}
                  onChange={(e) => onFilterChange(e)}
                />
                <Button className="search-submit btn-icon">
                  <Icon name="search"></Icon>
                </Button>
              </div>
            </div>
          </div>
        </div>
        <DataTableBody bodyclass="nk-tb-tnx">
          <DataTableHead className="nk-tb-item">
            <DataTableRow>
              <span>Order No.</span>
            </DataTableRow>
            <DataTableRow size="sm">
              <span>Customer</span>
            </DataTableRow>
            <DataTableRow size="md">
              <span>Items</span>
            </DataTableRow>
            <DataTableRow>
              <span>Amount</span>
            </DataTableRow>
            <DataTableRow>
              <span>Delivery Address</span>
            </DataTableRow>
            <DataTableRow>
              <span className=" ">Status</span>
            </DataTableRow>
            
          </DataTableHead>

          {isLoading ? (
            <MyLoader />
          ) : (
            <>
              {data?.length > 0
                ? data.map((item, idx) => (
                    <DataTableItem key={idx}>
                      <DataTableRow>
                        <span className="tb-lead" onClick={()=>onOrderClick(item)}>
                          <a href="#order" onClick={(ev) => ev.preventDefault()}>
                            {item.orderNum}
                          </a>
                        </span>
                      </DataTableRow>
                      <DataTableRow size="sm">
                        <div className="user-card">
                          <UserAvatar
                            className="sm"
                            theme={item?.theme}
                            text={getSmartInitials(item?.user_name)}
                            // image={BASE_URL_IMG + item.user_image}
                          ></UserAvatar>
                          <div className="user-name">
                            <span className="tb-lead text-capitalize">{item?.user_name}</span>
                          </div>
                        </div>
                      </DataTableRow>
                      <DataTableRow size="md">
                        <span className="tb-sub">{item.items}</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="tb-sub tb-amount">
                          {RUPEES_SYMBOL} {item.totalAmount}
                        </span>
                      </DataTableRow>
                      <DataTableRow size="md">
                        <span className="tb-sub text-capitalize">{item.address}</span>
                      </DataTableRow>
                     
                      <DataTableRow>
                        <Badge
                          className="badge-dot badge-dot-xs text-capitalize"
                          color={item.status === "paid" ? "success" : item.status === "due" ? "warning" : "danger"}
                        >
                          {item.status}
                        </Badge>
                      </DataTableRow>
                    </DataTableItem>
                  ))
                : null}
            </>
          )}
        </DataTableBody>
        <PreviewAltCard>
          {data?.length > 0 ? (
<>
         { pagination &&  <PaginationComponent
              itemPerPage={itemPerPage}
              totalItems={limit}
              paginate={paginate}
              currentPage={currentPage}
            />}
</>
          ) : (
            <div className="text-center">
              <span className="text-silent">No orders found</span>
            </div>
          )}
        </PreviewAltCard>
      </DataTable>
  );
};
export default RecentOrders;
